import { Instance } from "mobx-state-tree";
import { EmailCycleNamesStore } from "./EmailCycleNamesStore";
import { useProjectDetailsStore, useRespondentStore } from "../../store/Hooks";
import { CreateOrAssignEmailCycleStore } from "./CreateOrAssignEmailCycleStore";
import { AssignEmailCycleStore } from "./AssignEmailCycleStore";
import { CreateEmailCycleStore } from "./CreateEmailCycleStore";
import { EmailCyclesStore } from "./EmailCyclesStore";
import { EmailCycleDetailsStore } from "./EmailCycleDetailsStore";
import { UpdateEmailCycleStore } from "./UpdateEmailCycleStore";
import { DeleteEmailCycleStore } from "./DeleteEmailCycleStore";
import { StopEmailCycleStore } from "./StopEmailCycleStore";
import { EmailCycleRecipientsStore } from "./EmailCycleRecipientsStore";
import { PreviewEmailStore } from "./PreviewEmailStore";
import { GetInvestigationSummaryStore } from "./GetInvestigationSummaryStore";
import { ResendEmailStore } from "./ResendEmailStore";
import { DeliveryStatsForProjectStore } from "./DeliveryStatsForProjectStore";
import { DownloadStatsForProjectStore } from "./DownloadStatsForProjectStore";
import { DownloadEmailCycleRecipientsStore } from "./DownloadEmailCycleRecipientsStore";
import { OptOutScreenDetailsStore } from "./OptOutScreenDetailsStore";
import { useRootStore } from "../../root/store/RootStore";
import { OptOutOfCampaignStore } from "./OptOutOfCampaignStore";
import { RemoveEmailCycleRecipientStore } from "./RemoveEmailCycleRecipientStore";

export const useEmailCycleNamesStore = (): Instance<
  typeof EmailCycleNamesStore
> => useRespondentStore().emailCycleNamesStore;

export const useCreateOrAssignEmailCycleStore = (): Instance<
  typeof CreateOrAssignEmailCycleStore
> => useRespondentStore().createOrAssignEmailCycleStore;

export const useAssignEmailCycleStore = (): Instance<
  typeof AssignEmailCycleStore
> => useCreateOrAssignEmailCycleStore().assignEmailCycleStore;

export const useCreateEmailCycleStore = (): Instance<
  typeof CreateEmailCycleStore
> => useCreateOrAssignEmailCycleStore().createEmailCycleStore;

export const useEmailCyclesStore = (): Instance<typeof EmailCyclesStore> =>
  useProjectDetailsStore().emailCyclesStore;

export const useStopEmailCycleStore = (): Instance<
  typeof StopEmailCycleStore
> => useEmailCyclesStore().stopEmailCycleStore;

export const useEmailCycleDetailsStore = (): Instance<
  typeof EmailCycleDetailsStore
> => useProjectDetailsStore().emailCycleDetailsStore;

export const useUpdateEmailCycleStore = (): Instance<
  typeof UpdateEmailCycleStore
> => useEmailCycleDetailsStore().updateEmailCycleStore;

export const useDeleteEmailCycleStore = (): Instance<
  typeof DeleteEmailCycleStore
> => useEmailCycleDetailsStore().deleteEmailCycleStore;

export const useEmailCycleRecipientsStore = (): Instance<
  typeof EmailCycleRecipientsStore
> => useEmailCycleDetailsStore().emailCycleRecipientsStore;

export const useDownloadEmailCycleRecipientsStore = (): Instance<
  typeof DownloadEmailCycleRecipientsStore
> => useEmailCycleRecipientsStore().downloadEmailCycleRecipientsStore;

export const usePreviewEmailStore = (): Instance<typeof PreviewEmailStore> =>
  useEmailCycleDetailsStore().previewEmailStore;

export const useGetInvestigationSummaryStore = (): Instance<
  typeof GetInvestigationSummaryStore
> => useEmailCycleDetailsStore().getInvestigationSummaryStore;

export const useResendEmailStore = (): Instance<typeof ResendEmailStore> =>
  useEmailCycleDetailsStore().resendEmailStore;

export const useDeliveryStatsForProjectStore = (): Instance<
  typeof DeliveryStatsForProjectStore
> => useEmailCyclesStore().deliveryStatsForProjectStore;

export const useDownloadStatsForProjectStore = (): Instance<
  typeof DownloadStatsForProjectStore
> => useEmailCyclesStore().downloadStatsForProjectStore;

export const useOptOutScreenDetailsStore = (): Instance<
  typeof OptOutScreenDetailsStore
> => useRootStore().optOutScreenDetailsStore;

export const useOptOutOfCampaignStore = (): Instance<
  typeof OptOutOfCampaignStore
> => useOptOutScreenDetailsStore().optOutOfCampaignStore;

export const useRemoveEmailCycleRecipientStore = (): Instance<
  typeof RemoveEmailCycleRecipientStore
> => useEmailCycleRecipientsStore().removeEmailCycleRecipientStore;
